import format from 'date-fns/format'

/**
 * 月份转年 
 */
export function monthToYear(value) {
    const month = parseInt(value);
    if (month == 12) {
        return 1;
    } else if (month == 24){
        return 2;
    } else {
        return month;
    }
}

/**
 * 金额格式化 
 */
export function amountFormat(value) {
    const amount = parseFloat(value);
    if (amount > 10000) {
        return parseFloat(value / 10000);
    } else {
        return amount;
    }
}

/**
 * 金额单位格式化
 */
export function unitFormat(value) {
    const amount = parseInt(value);
    if (amount < 10000) {
        return '元';
    } else {
        return '万元';
    }
}

/**
 * 订单商品名称展示
 */
export function orderNameShow(value1,value2) {
    if(value1===2){
        return "网上炒股做赢家";
    }else{
        return value2;
    }
}

/**
 * 金额单位格式化
 */
export function amountUnitFormat(amount, month) {
    amount = parseInt(amount);
    month = parseInt(month);
    if (amount < 10000) {
        if (month < 12) {
            return amount + '元/'+ month +'月';
        }
        if (month === 12) {
            return amount + '元/年';
        } 
        if (month === 24) {
            return amount + '元/2年';
        }
    } else {
        amount = parseFloat(amount / 10000);
        if (month < 12) {
            return amount + '万元/'+ month +'月';
        }
        if (month === 12) {
            return amount + '万元/年';
        } 
        if (month === 24) {
            return amount + '万元/2年';
        }
    }
}
/**
 * 日期格式化 
 */
export function dateFormat(date, parttern='yyyy-MM-dd HH:mm:ss') {
    if (date) {
        return format(date,parttern)
    } else {
        return '';
    }
}
/**
 * 数字格式化 
 */
export function numFormat(value) {
    let realVal = parseFloat(value).toFixed(2)
    return realVal;
}


// WEBPACK FOOTER //
// ./src/filters/index.js